import { useMutation, UseMutationConfig } from '@libs/use';
import { UpdateVirtualPortfolioItemRequest } from '@libs/api-reference';

import * as API from '../../requests';

type UseUpdateVirtualPortfolioItemOptions = {
  onReject?: UseMutationConfig<object>['onReject'];
  onSuccess?: UseMutationConfig<object>['onSuccess'];
};

export default function useUpdateVirtualPortfolioItemQuery({
  onReject,
  onSuccess,
}: UseUpdateVirtualPortfolioItemOptions) {
  const {
    execute: updateVirtualPortfolioItem,
    isPending: isLoadingUpdateVirtualPortfolioItem,
    ...query
  } = useMutation<string>(
    ({ quantity, virtualAssetId, price }: UpdateVirtualPortfolioItemRequest) =>
      API.updateVirtualPortfolio({
        virtualAssetId,
        quantity,
        price,
      }),
    {
      onSuccess,
      onReject,
    }
  );

  return {
    updateVirtualPortfolioItem,
    isLoadingUpdateVirtualPortfolioItem,
    ...query,
  };
}
